import { parsePhoneNumberWithError } from 'libphonenumber-js';
import * as React from 'react';

type Props = {
    phoneNumber: string | null | undefined;
};

export default function DisplayPhoneNumber({ phoneNumber }: Props) {
    const formattedPhone = React.useMemo(() => {
        if (!phoneNumber) {
            return;
        }
        //do we need anything else? canada and the us are mostly the same
        try {
            const formattedNumber = parsePhoneNumberWithError(phoneNumber, 'US');
            if (formattedNumber) {
                //phoneNumber.isValid() === true
                return formattedNumber.formatNational();
            }
        } catch (e: any) {}

        return phoneNumber;
    }, [phoneNumber]);

    return <>{formattedPhone}</>;
}
